<template>
    <el-dialog
        :title="'日志'"
        :width="'800px'"
        :visible="true"
        :top="'10vh'"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'performanceWaybillNodeDailyDialog'"
    >
        <el-scrollbar style="height: 100%">
            <el-timeline>
                <el-timeline-item
                    v-for="item in rowData.orderMonitorList"
                    :key="item.id"
                    :type="'primary'"
                    :icon="'el-icon-circle-check'"
                >
                    <div class="itemLabel">{{ item.taskName }}</div>
                    <el-card class="box-card">
                        <p>要求完成时间：{{ item.requiredCompletionTime }}</p>
                        <p>实际完成时间：{{ item.realCompletionTime }}</p>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </el-scrollbar>
    </el-dialog>
</template>
<script>
export default {
    name: 'waybillNodeDailyDialog',
    props: {
        rowData: {
            type: Object,
            default () { return {}; }
        }
    },
    methods: {
        beforeClose () {
            this.$emit('update:waybillNodeDailyVisible', false);
        }
    }
};
</script>
<style lang="less">
.performanceWaybillNodeDailyDialog {
    .el-dialog__body {
        height: 600px;
        padding: 30px 16px 16px 30px;
        box-sizing: border-box;
    }
    .el-timeline {
        margin-left: 2px;
        .el-timeline-item__tail {
            border-left-color: #00bcbf;
        }
    }
    .el-timeline-item {
        padding-bottom: 10px;
        padding-right: 24px;
    }
    .itemLabel {
        margin-bottom: 10px;
    }
}
</style>